import * as contact from 'smg/customer-api/contact';
import { Session } from 'smg/customer-api/session';
import Modal from 'smg/modal';
import * as models from 'smg/customer-api/models';
import { Phone } from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';

export interface PromptQuantityRequestOptions {
    quote?: models.Quote;
    order?: models.Order;
    lineItem: models.QuoteLineItem | models.OrderLineItem;
}

export async function PromptQuantityRequest(opts: PromptQuantityRequestOptions) {
    const sess = await Session().catch(() => undefined);

    const body = template.Clone('#cart-revision-modal-form-template');
    const fullName = body.querySelector('#modal-full-name') as HTMLInputElement;
    const email = body.querySelector('#modal-email') as HTMLInputElement;
    const phone = body.querySelector('#modal-phone') as HTMLInputElement;
    const quantity = body.querySelector('#modal-requested-quantity') as HTMLInputElement;
    const message = body.querySelector('#modal-comments') as HTMLTextAreaElement;

    const p = new Phone(phone);

    if (sess) {
        fullName.value = sess.user.fullName();
        email.value = sess.user.emailAddress.email;
        void p.ready().then(() =>
            p.iti.setNumber(sess.user.phoneNumber.phone));
    }

    const $reCaptchaPlaceholder = body.querySelector('#modal-recaptcha') as HTMLElement;

    let lineItemIndex = 0;
    if (opts.lineItem instanceof models.QuoteLineItem && opts.quote?.quoteLineItems) {
        lineItemIndex = opts.quote.quoteLineItems.indexOf(opts.lineItem) + 1;
    } else if (opts.lineItem instanceof models.OrderLineItem && opts.order?.orderLineItems) {
        lineItemIndex = opts.order.orderLineItems.indexOf(opts.lineItem) + 1;
    }

    new Modal({
        title: 'Quantity Change Request',
        outsideClosable: false,
        size: 'modal-lg',
        body,
        onSubmit: () => {
            const contactData: contact.CreateContactOpts = {
                name: fullName.value,
                company: sess?.user.company || '',
                phone: p,
                email: email.value,
                content:
                    `Qty update request for ${opts.quote ? `quote #${opts.quote.serial ?? ''}` : `order #${opts.order?.invoiceNumber ?? ''}`}

                New qty requested: ${quantity.value}
                For line item #${lineItemIndex || ''}

                Other comments:
                ${message.value.trim() || 'None'}`,
                ignoreSMSPreference: true,
                $reCaptchaPlaceholder,
            };
            return contact.CreateContact(contactData).then(() => {
                toast.Success('Your request has been submitted!');
            });
        },

    });
}